"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReportSdk = createReportSdk;
const axios_1 = __importDefault(require("axios"));
const generated_1 = require("../generated");
const sdkHelper_1 = require("./sdkHelper");
function createReportSdk(init, enhancer) {
    return _create(init, enhancer);
}
function _create(config, enhancer) {
    if (enhancer) {
        return enhancer(_create)(config);
    }
    const apiConfig = new generated_1.Configuration({
        basePath: config.baseUrl,
    });
    const client = config.axios ?? axios_1.default.create();
    // TODO fix openapi generator to properly deserialize dates
    client.interceptors.response.use((response) => {
        if (response.data && typeof response.data === 'object') {
            response.data = (0, sdkHelper_1.convertDates)(response.data);
        }
        return response;
    }, (error) => {
        return Promise.reject(error);
    });
    return new generated_1.DefaultApi(apiConfig, config.baseUrl, client);
}
//# sourceMappingURL=sdkProvider.js.map